import React, { Component } from "react";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";
import utils from "@utils";
import { Modal } from "../../../../components";

class ConvertEstimateModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			dueDate: "",
			errorMsg: "",
		};
		this.dateMask = [/[0-1]/, /[0-9]/, "/", /[0-3]/, /[0-9]/, "/", /2/, /0/, /[2-9]/, /[0-9]/];
	}

	onEnter = () => {
		const { invoiceVersion, issueDate } = this.props;
		if (invoiceVersion === 3) {
			this.setState({ dueDate: issueDate });
		}
	};

	changeDueDate = event => {
		const {
			target: { value },
		} = event;

		this.setState({ dueDate: value, errorMsg: "" });
	};

	/**
	 * Validates that each dates is valid by compoaring against a specfic regular expression
	 * @returns {Boolean} Determines if the specified dates are valid
	 */
	areDatesValid = () => {
		const { lang } = global;
		const { dueDate } = this.state;
		const { issueDate } = this.props;

		// If either date is blank, they are not valid
		if (issueDate === "" || dueDate === "") {
			this.setState({
				errorMsg: lang.t("Issue Date and Due Date are required to save an invoice"),
			});
			return false;
		}
		// By default, we will test both dates against a yyyy-mm-dd format
		let dateRegex = /(\d{4})-(\d{2})-(\d{2})/;
		if (utils.isDesktopSafari || utils.isIE) {
			// Make sure the due date is after the issue date
			const selectedIssueDate = new Date(`${issueDate} 00:00`);
			const selectedDueDate = new Date(`${dueDate} 00:00`);
			if (selectedIssueDate.getTime() > selectedDueDate.getTime()) {
				this.setState({
					errorMsg: lang.t("Invoice due date must be on or after the issue date"),
				});
				return false;
			}
			// If all previous checks are met on Safari/IE, we should test against a mm/dd/yyyy format
			dateRegex = /(\d{2})\/(\d{2})\/(\d{4})/;
		} else {
			// Verify that a date selected without using the datepicker is not before the invoice issue date
			const selectedIssueDate = new Date(`${issueDate}T00:00:00`);
			const selectedDueDate = new Date(`${dueDate}T00:00:00`);
			if (selectedIssueDate.getTime() > selectedDueDate.getTime()) {
				this.setState({
					errorMsg: lang.t("Invoice due date must be on or after the issue date"),
				});
				return false;
			}
		}
		return dateRegex.test(issueDate) && dateRegex.test(dueDate);
	};

	setDueDate = () => {
		const { dueDate } = this.state;
		const { onConfirm } = this.props;
		if (this.areDatesValid()) {
			onConfirm(dueDate);
			this.onHide();
		}
	};

	onHide = () => {
		const { onCancel } = this.props;
		onCancel();
		this.setState({ dueDate: "", errorMsg: "" });
	};

	render() {
		const { lang } = global;
		const { dueDate, errorMsg } = this.state;
		const { show, issueDate } = this.props;

		return (
			<Modal
				id="convert-estimate-modal"
				show={show}
				onEnter={this.onEnter}
				onHide={this.onHide}
			>
				<Modal.Header>
					<Modal.Title>{lang.t("Confirm")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row text-center">
						<p className="col-sm-12">
							{lang.t("Converting an estimate to an invoice cannot be undone_")}
							&nbsp;
							{lang.t(
								"To convert this estimate, please select a due date for the invoice_",
							)}
						</p>
					</div>
					<div className="row">
						<div className="col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4 form-group">
							<label htmlFor="convert-dueDate">{lang.t("Due Date")}</label>
							<Choose>
								<When condition={utils.isDesktopSafari || utils.isIE}>
									<MaskedInput
										name="convert-dueDate"
										id="convert-dueDate"
										type="text"
										mask={this.dateMask}
										className={`form-control${errorMsg ? " has-error" : ""}`}
										placeholder="mm/dd/yyyy"
										value={dueDate}
										onChange={this.changeDueDate}
										onKeyPress={({ key }) => {
											if (key === "Enter") this.setDueDate();
										}}
									/>
								</When>
								<Otherwise>
									<input
										name="convert-dueDate"
										id="convert-dueDate"
										className={`form-control${errorMsg ? " has-error" : ""}`}
										type="date"
										min={issueDate}
										value={dueDate}
										onChange={this.changeDueDate}
										onKeyPress={({ key }) => {
											if (key === "Enter") this.setDueDate();
										}}
									/>
								</Otherwise>
							</Choose>
						</div>
					</div>
					<div className="row text-center">
						<div className="col-sm-12 text-danger">{errorMsg}</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						className="btn btn-link"
						onClick={this.onHide}
					>
						{lang.t("Cancel")}
					</button>
					<button
						type="button"
						className="btn btn-primary"
						onClick={this.setDueDate}
					>
						{lang.t("Continue")}
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

ConvertEstimateModal.propTypes = {
	issueDate: PropTypes.string.isRequired,
	show: PropTypes.bool,
	invoiceVersion: PropTypes.number,
	onCancel: PropTypes.func,
	onConfirm: PropTypes.func,
};

ConvertEstimateModal.defaultProps = {
	show: false,
	invoiceVersion: 2,
	onCancel: () => {},
	onConfirm: () => {},
};

export default ConvertEstimateModal;
